import React from 'react';
import { withTranslation } from 'react-i18next';
import Button from '../design-system/components/atoms/button';
import { accessibleOnClick } from '../utils/accessible-on-click';
import { openChatSupport } from '../utils/open-chat-support';
import S3StaticImage from '../utils/s3-static-images';
import CrashReportDetailForm from '../components/crash-report-detail-form/crash-report-detail';
import { ErrorBoundaryUIProps } from './types';

const ErrorFallback: React.FC<ErrorBoundaryUIProps> = ({
  t,
  crashReportId,
  errorMessage,
  componentStack,
}) => (
  <>
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 px-4">
      <span className="semibold-3 gray-txt-17">
        {t('messages.error_boundary_title')}
      </span>
      <div className="mt-5">
        <S3StaticImage imagePath="broken.svg" alt="broken" />
      </div>
      <span className="mt-5 regular-3 font-weight-500 gray-txt-15">
        {t('messages.error_boundary_sub_text_one')}
      </span>
      <div className="mt-2">
        <span className="regular-3 font-weight-500 gray-txt-15">
          {t('messages.error_boundary_sub_text_two')}
        </span>
        <span
          {...accessibleOnClick(openChatSupport)}
          className="ml-1 regular-3 font-weight-500 blue-txt-11 pointer"
        >
          {t('labels.Contact_Support')}.
        </span>
      </div>

      <Button
        variant={Button.Variant.Primary}
        {...accessibleOnClick(() => window.location.reload())}
        className="mt-4"
      >
        {t('messages.return_to_application')}
      </Button>
    </div>
    <CrashReportDetailForm
      crashReportId={crashReportId}
      errorMessage={errorMessage}
      componentStack={componentStack}
      t={t}
    />
  </>
);

export default withTranslation()(ErrorFallback);
